// charm 魅力等级相关API
import request from '@/utils/request'
// 列表
export function joinCompanyList(data) {
  return request({
    url: '/admin/yuzhiJoinCompany/list',
    method: 'post',
    data
  })
}
export function guochuanping(data) {
  return 2333333888888999999
}
// 审核通过接口
export function accept(data) {
  return request({
    url: '/admin/yuzhiJoinCompany/accept',
    method: 'post',
    data
  })
}

// 审核拒绝接口
export function reject(data) {
  return request({
    url: '/admin/yuzhiJoinCompany/reject',
    method: 'post',
    data
  })
}

// 列表
export function zhuChangList(data) {
  return request({
    url: '/admin/yuzhiZhuchang/list',
    method: 'post',
    data
  })
}

// 区域列表
export function quyuList(data) {
  return request({
    url: '/admin/common/allQuyu',
    method: 'post',
    data
  })
}

// 删除
export function zhuChangDelete(data) {
  return request({
    url: '/admin/yuzhiZhuchang/delete',
    method: 'post',
    params: data
  })
}
// 所有企业
export function allCompany(data) {
  return request({
    url: '/admin/common/allCompany',
    method: 'post',
    data
  })
}
// 驻场管理添加
export function zhuchangSave(data) {
  return request({
    url: '/admin/yuzhiZhuchang/save',
    method: 'post',
    params: data
  })
}
// 驻场管理更新
export function zhuchangUpdate(data) {
  return request({
    url: '/admin/yuzhiZhuchang/update',
    method: 'post',
    params: data
  })
}
// 驻场ids
export function zhuchangIds(data) {
  return request({
    url: '/admin/common/zhuchangIds',
    method: 'post',
    params: data
  })
}

// 区域列表
export function yuzhiQuyu(data) {
  return request({
    url: '/admin/yuzhiQuyu/list',
    method: 'post',
    data
  })
}
// 区域保存
export function yuzhiQuyuSave(data) {
  return request({
    url: '/admin/yuzhiQuyu/save',
    method: 'post',
    data
  })
}
// 区域更新
export function yuzhiQuyuUpdate(data) {
  return request({
    url: '/admin/yuzhiQuyu/update',
    method: 'post',
    data
  })
}
// 区域删除
export function yuzhiQuyuDelete(data) {
  return request({
    url: '/admin/yuzhiQuyu/delete',
    method: 'post',
    data
  })
}
// 驻场
export function allZhuchang(data) {
  return request({
    url: '/admin/common/allZhuchang',
    method: 'post',
    data
  })
}

// 列表
export function applyList(data) {
  return request({
    url: '/admin/yuzhiApply/list',
    method: 'post',
    data
  })
}
// 流程详情
export function progress(data) {
  return request({
    url: `/admin/yuzhiApply/progress`,
    method: 'post',
    data
  })
}

// 财务管理列表
export function caiwuList(data) {
  return request({
    url: `/admin/yuzhiCaiwu/list`,
    method: 'post',
    data
  })
}
// 区域
export function allDaquyu(data) {
  return request({
    url: `/admin/common/allDaquyu`,
    method: 'post',
    data
  })
}
// 财务管理保存
export function yuzhiCaiwuSave(data) {
  return request({
    url: `/admin/yuzhiCaiwu/save`,
    method: 'post',
    data
  })
}
// 财务管理编辑
export function yuzhiCaiwuUpdte(data) {
  return request({
    url: `/admin/yuzhiCaiwu/update`,
    method: 'post',
    data
  })
}
// 区域
export function yuzhiCaiwuDelete(data) {
  return request({
    url: `/admin/yuzhiCaiwu/delete`,
    method: 'post',
    params: data
  })
}
// 区域
export function yuzhidaquyuSave(data) {
  return request({
    url: `/admin/yuzhiDaquyu/save`,
    method: 'post',
    params: data
  })
}

// 大区域编辑
export function edit(data) {
  return request({
    url: `/admin/yuzhiDaquyu/getById`,
    method: 'post',
    params: data
  })
}

// 更新
export function yuzhiDaquyuUpdate(data) {
  return request({
    url: `/admin/yuzhiDaquyu/update`,
    method: 'post',
    params: data
  })
}

// 大区域删除
export function yuzhidaQuyuDelete(data) {
  return request({
    url: '/admin/yuzhiDaquyu/delete',
    method: 'post',
    data
  })
}

// 大区域List
export function yuzhidaQuyuList(data) {
  return request({
    url: '/admin/yuzhiDaquyu/list',
    method: 'post',
    data
  })
}

// 大区域ids
export function daquyuIds(data) {
  return request({
    url: '/admin/common/daquyuIds',
    method: 'post',
    data
  })
}

// 区域ids
export function quyuIds(data) {
  return request({
    url: '/admin/common/quyuIds',
    method: 'post',
    params: data
  })
}

// 批量打款
export function agreeList(data) {
  return request({
    url: '/admin/yuzhiApply/agreeList',
    method: 'post',
    params: data
  })
}

// 批量拒绝
export function refuseList(data) {
  return request({
    url: '/admin/yuzhiApply/refuseList',
    method: 'post',
    params: data
  })
}

// 批量删除(预支申请)
export function deleteList(data) {
  return request({
    url: '/admin/yuzhiApply/delete',
    method: 'post',
    params: data
  })
}

// 批量删除(大区域)
export function yuzhiDaquyuDel(data) {
  return request({
    url: '/admin/yuzhiDaquyu/delete',
    method: 'post',
    params: data
  })
}

// 批量删除(区域)
export function yuzhiQuyuDel(data) {
  return request({
    url: '/admin/yuzhiQuyu/delete',
    method: 'post',
    params: data
  })
}

// 批量删除(绑定公司)
export function yuzhiJoinCompanyDel(data) {
  return request({
    url: '/admin/yuzhiJoinCompany/delete',
    method: 'post',
    params: data
  })
}

// 批量删除(财务管理)
export function yuzhiCaiwuDel(data) {
  return request({
    url: '/admin/yuzhiCaiwu/delete',
    method: 'post',
    params: data
  })
}

// 批量删除(驻场管理)
export function yuzhiZhuchangDel(data) {
  return request({
    url: '/admin/yuzhiZhuchang/delete',
    method: 'post',
    params: data
  })
}

export function reqCompanyAccountByIds(data) {
  return request({
    url: '/admin/common/memberIds',
    method: 'post',
    data
  })
}
export function reqCompanyByIds(data) {
  return request({
    url: '/admin/common/companyIds',
    method: 'post',
    data
  })
}

